/**
 * Vista previa visual de cómo podría verse una notificación del sistema (estilo Android).
 * Reutilizable en ajustes, onboarding o documentación in-app.
 */

import React from "react";
import { ALTENOT_NOTIFICATION_BRAND } from "./mobileNotificationDesign";

export interface MobileNotificationPreviewProps {
  title: string;
  body: string;
  /** Hora mostrada a la derecha (ej. "ahora", "14:32") */
  timeLabel?: string;
  /** Nombre corto de la app en la cabecera */
  appName?: string;
}

export const MobileNotificationPreview: React.FC<
  MobileNotificationPreviewProps
> = ({
  title,
  body,
  timeLabel = "ahora",
  appName = ALTENOT_NOTIFICATION_BRAND.appName,
}) => {
  return (
    <div
      className="rounded-2xl border border-gray-200 dark:border-slate-600 bg-gray-100/90 dark:bg-slate-900/90 p-3 shadow-inner"
      role="img"
      aria-label={`Vista previa de notificación: ${title}`}
    >
      <p className="text-[9px] font-bold uppercase tracking-wider text-gray-500 dark:text-slate-500 mb-2 px-0.5">
        Vista previa (móvil)
      </p>
      <div className="flex gap-3 rounded-xl bg-white dark:bg-slate-800 px-3 py-2.5 shadow-md border border-gray-100 dark:border-slate-700">
        <div
          className="w-10 h-10 rounded-xl flex-shrink-0 flex items-center justify-center text-white text-xs font-black shadow-sm"
          style={{ backgroundColor: ALTENOT_NOTIFICATION_BRAND.colorAccent }}
        >
          A
        </div>
        <div className="flex-1 min-w-0 pt-0.5">
          <div className="flex items-start justify-between gap-2">
            <p className="text-[11px] font-bold text-gray-900 dark:text-slate-100 truncate">
              {appName}
            </p>
            <span className="text-[10px] text-gray-400 dark:text-slate-500 flex-shrink-0">
              {timeLabel}
            </span>
          </div>
          <p className="text-xs font-semibold text-gray-800 dark:text-slate-200 mt-0.5 leading-snug">
            {title}
          </p>
          <p className="text-[11px] text-gray-600 dark:text-slate-400 mt-0.5 leading-snug line-clamp-3">
            {body}
          </p>
        </div>
      </div>
    </div>
  );
};
